import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { loginAdmin, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Login Admin — PT. Cahaya Sakofa Mulia";
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await loginAdmin(email, password);
      localStorage.setItem("csm_token", res.token);
      toast.success("Berhasil masuk");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-brand-dark focus:outline-none focus:ring-2 focus:ring-brand";

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-mist px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_16px_50px_rgb(0,86,179,0.08)] sm:p-10">
        <div className="flex flex-col items-center text-center">
          <img src="/assets/logo.jpeg" alt="Logo PT. Cahaya Sakofa Mulia" className="h-16 w-16 rounded-2xl object-cover" />
          <h1 className="mt-5 font-display text-2xl font-bold text-brand-dark">Admin Dashboard</h1>
          <p className="mt-1 text-sm text-slate-500">PT. CAHAYA SAKOFA MULIA</p>
        </div>
        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Email</label>
            <input id="admin-email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@contoh.com" className={inputCls} />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Password</label>
            <input id="admin-password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-brand px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-deep active:scale-95 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Masuk
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-slate-400">
          <Link to="/" className="transition-colors hover:text-brand" data-testid="admin-back-to-site">← Kembali ke website</Link>
        </p>
      </div>
    </div>
  );
}
